import { useEffect, useState, useCallback } from 'react';
import { debounce } from 'lodash';

const DEBOUNCED_INTERVAL = 400;

const useDebouncedState = (dataToDebounce, setter) => {
    const [innerValue, setInnerValue] = useState(dataToDebounce);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedSetter = useCallback(debounce(setter, DEBOUNCED_INTERVAL), [
        setter,
    ]);

    const setDebouncedState = useCallback(
        (newData) => {
            setInnerValue(newData);
            debouncedSetter(newData);
        },
        [debouncedSetter]
    );

    useEffect(() => {
        setInnerValue(dataToDebounce);
    }, [dataToDebounce]);

    return [innerValue, setDebouncedState];
};

export default useDebouncedState;
